/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const EpisodeOfCareStatus = {
    Planned: 'planned',
    Waitlist: 'waitlist',
    Active: 'active',
    Onhold: 'onhold',
    Finished: 'finished',
    Cancelled: 'cancelled',
} as const;
export type EpisodeOfCareStatus = typeof EpisodeOfCareStatus[keyof typeof EpisodeOfCareStatus];


export function instanceOfEpisodeOfCareStatus(value: any): boolean {
    for (const key in EpisodeOfCareStatus) {
        if (Object.prototype.hasOwnProperty.call(EpisodeOfCareStatus, key)) {
            if (EpisodeOfCareStatus[key as keyof typeof EpisodeOfCareStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function EpisodeOfCareStatusFromJSON(json: any): EpisodeOfCareStatus {
    return EpisodeOfCareStatusFromJSONTyped(json, false);
}

export function EpisodeOfCareStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): EpisodeOfCareStatus {
    return json as EpisodeOfCareStatus;
}

export function EpisodeOfCareStatusToJSON(value?: EpisodeOfCareStatus | null): any {
    return value as any;
}

export function EpisodeOfCareStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): EpisodeOfCareStatus {
    return value as EpisodeOfCareStatus;
}

